import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f35a666e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "banner" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_typography_paragraph = _resolveComponent("a-typography-paragraph")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_typography_title, { level: 1 }, {
        default: _withCtx(() => [
          _createTextVNode(" CostPilot"),
          _hoisted_3,
          _createTextVNode(" 一站式企业云成本管家 ")
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_a_typography_paragraph, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString('CostPilot是基于FinOps理念开发的一站式企业云成本管理平台，' +
          '通过对各种云资源成本的深入洞察，快速生成成本报告，' +
          '并从多种角度提供定制化成本优化建议，助力企业IT成本优化高达50%。'))
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_a_space, {
        size: _ctx.$Store.Public().isGridMatch('>=',_ctx.$Enum.GridEnum.XL)?'large':'small'
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_button, {
            type: "link",
            class: "button_1",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$RQ.GoGSS()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 免费体验 ")
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_a_button, {
            type: "link",
            class: "button_1",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$Store.Page().openModal('modalFormCollection', 'demoCostPilot')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 预约咨询 ")
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["size"])
    ])
  ]))
}